import { Container } from '@ui/wrapper'
import BoxImage from '@components/box-image/layout-11'
import { SectionWrapper } from './style'
import { faBookOpen } from '@fortawesome/pro-regular-svg-icons/faBookOpen'

const JahresberichteArea = ({ data, ...rest }) => {
  return (
    <SectionWrapper {...rest}>
      <Container>
        {data.items?.map(
          (item) =>
            item && (
              <BoxImage
                key={item.id}
                title={item.title}
                desc={item.description}
                image={item.images[0]}
                icon={faBookOpen}
                path={item.pdfs[0]?.src.localFile.publicURL || item.path}
                showTitle={rest.showTitle ? true : false}
                openInFlipbook
                allowDownload={rest.allowDownload !== false}
                leftCol={2}
                rightCol={10}
              />
            )
        )}
      </Container>
    </SectionWrapper>
  )
}

export default JahresberichteArea
